import { campaignDeliveryTypeService } from "@/services/campaign-delivery-type.service";
import { GetterTree, MutationTree, ActionTree, Module } from "vuex";
import { RootState } from "..";
import { ICampaignDeliveryTypeState } from "../states/campaign-delivery-type-state";

export const state: ICampaignDeliveryTypeState = {
  campaignDeliveryTypes: []
};

export const getters: GetterTree<ICampaignDeliveryTypeState, RootState> = {
  campaignDeliveryTypes(state) {
    return state.campaignDeliveryTypes;
  }
};

export const mutations: MutationTree<ICampaignDeliveryTypeState> = {
  campaignDeliveryTypes(state, campaignDeliveryTypes) {
    state.campaignDeliveryTypes = campaignDeliveryTypes;
  }
};

export const actions: ActionTree<ICampaignDeliveryTypeState, RootState> = {
  async retrieveCampaignDeliveryTypes({ commit }) {
    return new Promise((resolve) => {
      campaignDeliveryTypeService.get()
        .then((value) => {
          if (value && value.success) {
            commit("campaignDeliveryTypes", value.result);
            resolve(value.success);
          }
          resolve(false);
        });
    });
  }
};

export const campaignDeliveryTypeModule: Module<ICampaignDeliveryTypeState, RootState> = {
  state, getters, mutations, actions, namespaced: true
};
